module.exports = __webpack_public_path__ + "img/google-play-badge-fr.4b14895b.png";